import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { CORE_CONFIG } from '../environment';
import { Observable } from 'rxjs';
import { AutoTablePageableResponse } from '@muchencute/mrrs-types';
import { Tendency, TendencyData, TendencyStatus } from './tendency-models';

/**
 * @since 1.1.0
 */
@Injectable({
  providedIn: 'root'
})
export class TendencyService {

  private _baseURL: string;

  constructor(private httpClient: HttpClient,
    private authService: AuthService,
    @Inject(CORE_CONFIG) private coreConfig: any) {
    this._baseURL = `${this.coreConfig.endpoint}api/v1/tendenc`;
  }

  getTendencies(params: { [name: string]: any }): Observable<AutoTablePageableResponse<Tendency>> {
    return this.httpClient.get<AutoTablePageableResponse<Tendency>>(`${this._baseURL}ies`, { params: params });
  }

  getTendency(id: number): Observable<Tendency> {
    return this.httpClient.get<Tendency>(`${this._baseURL}y/${id}`);
  }

  newTendency(tendency: Tendency): Observable<any> {
    return this.httpClient.post(`${this._baseURL}y`, tendency);
  }

  updateTendency(tendency: Tendency): Observable<any> {
    return this.httpClient.put(`${this._baseURL}y/${tendency.code}`, tendency);
  }

  removeTendency(id: number): Observable<any> {
    return this.httpClient.delete(`${this._baseURL}y/${id}`);
  }

  updateTendencyStatus(id: number, status: TendencyStatus): Observable<any> {
    return this.httpClient.patch(`${this._baseURL}y/${id}`, {}, {
      params: {
        status
      }
    });
  }

  /**
   * @since 1.2.8
   */
  getTendencyDataList(id: number, params: { [name: string]: any }): Observable<AutoTablePageableResponse<TendencyData>> {
    return this.httpClient.get(`${this._baseURL}y/${id}/data`, { params: params });
  }

  addTendencyData(id: number, data: TendencyData): Observable<any> {
    return this.httpClient.post(`${this._baseURL}y/${id}/data`, data);
  }

  updateTendencyData(id: number, data: TendencyData): Observable<any> {
    return this.httpClient.put(`${this._baseURL}y/${id}/data/${data.date}`, data);
  }

  removeTendencyData(id: number, date: string): Observable<any> {
    return this.httpClient.delete(`${this._baseURL}y/${id}/data/${date}`);
  }
}
